import React from 'react';
import Logo from '@assets/icons/svg/SmallLogo.svg';
import {SmallLogoGrid} from './SmallLogoComponentStyles';
import {useNavigate} from 'react-router-dom';
import {PUBLIC_ROUTES} from 'src/routes/RouteConstants';
import {BASE_ROUTE} from 'src/routes/BaseRoute';

const SmallLogoComponent = (): JSX.Element => {
  const navigate = useNavigate();
  const goToLoginPage = () => {
    navigate(`/${BASE_ROUTE}/` + PUBLIC_ROUTES.LOGIN);
  };
  return (
    <SmallLogoGrid>
      <img
        src={Logo}
        alt="logo"
        onClick={goToLoginPage}
        style={{cursor: 'pointer', margin: '0 auto', width: '30px'}}
      />
      {/* </IconButton> */}
    </SmallLogoGrid>
  );
};

export default SmallLogoComponent;
